module.exports = __webpack_public_path__ + "img/code.fbfaa920.png";